var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferrals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_475_3135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.6875 21.687V21.1377L6.89969 22.3499L8.22538 21.0242L4.75 17.4863L1.27469 21.0241L2.60038 22.3498L3.8125 21.1377V21.687C3.8125 26.3397 7.59731 30.1245 12.25 30.1245H15.0625V28.2495H12.25C8.63181 28.2495 5.6875 25.3052 5.6875 21.687Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.25 10.375V10.9243L26.0378 9.71212L24.7121 11.0378L28.1875 14.5132L31.6628 11.0379L30.3371 9.71219L29.125 10.9243V10.375C29.125 5.72231 25.3402 1.9375 20.6875 1.9375H17.875V3.8125H20.6875C24.3057 3.8125 27.25 6.75681 27.25 10.375Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1411 16.0778C11.7504 14.4246 10.2712 13.1875 8.5 13.1875C6.72881 13.1875 5.24962 14.4246 4.85894 16.0778C5.96569 16.6121 7.19081 16.9375 8.5 16.9375C9.80919 16.9375 11.0343 16.6121 12.1411 16.0778Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.4375C9.53553 9.4375 10.375 8.59803 10.375 7.5625C10.375 6.52697 9.53553 5.6875 8.5 5.6875C7.46447 5.6875 6.625 6.52697 6.625 7.5625C6.625 8.59803 7.46447 9.4375 8.5 9.4375Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.22906 15.0351C4.013 12.8714 6.06881 11.3125 8.5 11.3125C6.43181 11.3125 4.75 9.63069 4.75 7.5625C4.75 5.49431 6.43181 3.8125 8.5 3.8125C10.5682 3.8125 12.25 5.49431 12.25 7.5625C12.25 9.63069 10.5682 11.3125 8.5 11.3125C10.9311 11.3125 12.9871 12.8714 13.7711 15.0351C15.6861 13.4871 16.9375 11.1488 16.9375 8.5C16.9375 3.84731 13.1527 0 8.5 0C3.84731 0 0 3.84731 0 8.5C0 11.1488 1.314 13.4871 3.22906 15.0351Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 28.25C21.7288 28.25 20.2496 29.4871 19.8589 31.1403C20.9657 31.6746 22.1908 32 23.5 32C24.8092 32 26.0343 31.6746 27.1411 31.1403C26.7504 29.4871 25.2712 28.25 23.5 28.25Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 24.5C24.5355 24.5 25.375 23.6605 25.375 22.625C25.375 21.5895 24.5355 20.75 23.5 20.75C22.4645 20.75 21.625 21.5895 21.625 22.625C21.625 23.6605 22.4645 24.5 23.5 24.5Z",
    fill: "#6366F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.0625C18.8473 15.0625 15.0625 18.9098 15.0625 23.5625C15.0625 26.2113 16.314 28.5496 18.2291 30.0976C19.013 27.9339 21.0688 26.375 23.5 26.375C21.4318 26.375 19.75 24.6932 19.75 22.625C19.75 20.5568 21.4318 18.8125 23.5 18.8125C25.5682 18.8125 27.25 20.5568 27.25 22.625C27.25 24.6932 25.5682 26.375 23.5 26.375C25.9311 26.375 27.9871 27.9339 28.7711 30.0976C30.6861 28.5496 32 26.1488 32 23.5C32 19.0139 28.1527 15.0625 23.5 15.0625Z",
    fill: "#6366F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_475_3135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/referrals.2cfcd24814477de49a5db4efdae41409.svg";
export { ForwardRef as ReactComponent };